import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "boxMessage" }
const _hoisted_2 = { class: "eventCard news survey" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_survey icon" }, null, -1)
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "none date" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_calendar" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-R" }, null, -1)
const _hoisted_10 = { class: "when" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h2", null, _toDisplayString(_ctx.item.details.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", null, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(_ctx.$moment(_ctx.item.details.start_date).format("DD.MM.YYYY")) + " - " + _toDisplayString(_ctx.$moment(_ctx.item.details.end_date).format("DD.MM.YYYY")), 1)
              ])
            ])
          ])
        ]),
        _hoisted_8,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startSurvey(_ctx.item.details.url))),
          class: "next defaultButton"
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("survey.start")) + " ", 1),
          _hoisted_9
        ])
      ]),
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$moment(_ctx.item.created_at).fromNow()), 1)
    ])
  ]))
}